import { createContext } from "react";
import { emptyLead, ILead } from "../../../../types/lead.type";

type InitialStateType = {
  lead: ILead
  saveLead: (Data: ILead) => Promise<{
    ok: boolean;
    data: ILead;
    errors: Array<{
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      message: string | any;
      path: string[] | never[];
    }>;
  }>;
};


export const initialState: InitialStateType = {
  lead: emptyLead(),
  saveLead: () => Promise.reject({
    ok: false,
    data: emptyLead(),
    errors: [
      {
        message: "not-implemented",
        path: ["."]
      }
    ]
  })
};

// Context separado
export const LeadDashboardContext = createContext(initialState)